import { render } from "./GlobalParameterValue.vue?vue&type=template&id=35f59090&ts=true"
import script from "./GlobalParameterValue.vue?vue&type=script&lang=ts"
export * from "./GlobalParameterValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__